import { render, staticRenderFns } from "./lanzhouindex.vue?vue&type=template&id=ab6f446e&scoped=true&"
import script from "./lanzhouindex.vue?vue&type=script&lang=js&"
export * from "./lanzhouindex.vue?vue&type=script&lang=js&"
import style0 from "./lanzhouindex.vue?vue&type=style&index=0&id=ab6f446e&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6f446e",
  null
  
)

export default component.exports